export enum ActionState {
    NoAction,
    Loading,
    Succeeded,
    Failed
}
